import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Textfit } from 'react-textfit';

import Angle from '../../../../../../../components/global/Angle';

const propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  hasChildren: PropTypes.bool,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  expanded: PropTypes.bool,
};

const MembershipsNavigationTrigger = forwardRef(
  ({ title, subtitle, hasChildren, onClick, loading, expanded }, ref) => {
    const classes = classNames({
      'membership-nav-trigger': true,
      'is-loading': loading,
    });

    return (
      <button className={classes} onClick={onClick} ref={ref}>
        <div className="membership-nav-trigger-content">
          <div className="membership-nav-trigger-title">
            <Textfit mode="single" min={12} max={16}>
              {title}
            </Textfit>
          </div>
          <div className="membership-nav-trigger-subtitle">{subtitle}</div>
        </div>

        {hasChildren && <Angle direction={expanded ? 'up' : 'down'} />}
      </button>
    );
  },
);

MembershipsNavigationTrigger.propTypes = propTypes;
MembershipsNavigationTrigger.displayName = 'MembershipsNavigationTrigger';

export default MembershipsNavigationTrigger;
